import React, { useContext, useEffect, useRef } from 'react';
import ScrollContext from './scroll-context';

type Props = {
  id: string;
  focusOn?: any;
};
export default function ScrollAnchor({ id, focusOn }: Props) {
  const context = useContext(ScrollContext);
  const ref = useRef(null);
  useEffect(() => {
    const { anchors } = context;
    if (!anchors.includes({ aRef: ref, focusOn })) {
      anchors.push({ aRef: ref, focusOn });
    }
    return () => {
      context.anchors = anchors.filter((a) => a.aRef !== ref);
    };
  }, [context, ref, id, focusOn]);

  return (
    <a id={`scroll-anchor-${id}`} ref={ref} style={{ paddingTop: '30px' }} />
  );
}
